<ion-card *ngIf="mobileType === 'android'">
  <ion-card-header>
    <ion-card-title>Instala la aplicación en tu pantalla de inicio</ion-card-title>
  </ion-card-header>
  <ion-card-content class="android-content">
    <ion-button color="primary" (click)="installPwa()">
      Instalar
    </ion-button>
    <ion-button fill="clear" color="danger" (click)="close()">
      Cerrar
    </ion-button>
  </ion-card-content>
</ion-card>

<ion-card *ngIf="mobileType === 'ios'">
  <ion-card-header>
    <ion-card-title>Instala la aplicación en tu pantalla de inicio</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <div>Para agregar esta aplicación a tu escritorio presion el boton de menu y luego el boton de 'Agregar a Inicio'
    </div>
    <div class="images">
      <img src="assets/img/ios-menu-btn.png">
      <ion-icon name="play"></ion-icon>
      <img src="assets/img/ios-add-btn.png">
    </div>
    <ion-button fill="clear" size="block" color="danger" (click)="close()">
      Cerrar
    </ion-button>
  </ion-card-content>
</ion-card>